// extracted by mini-css-extract-plugin
module.exports = {"bullets":"styles_bullets__ad8dv","root":"styles_root__q4yzY"};